
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class SecurityRepairLogDialog extends SiteEntityDialog<SecurityRepairLogRow, any> {
        protected getFormKey() { return SecurityRepairLogForm.formKey; }
        protected getIdProperty() { return SecurityRepairLogRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityRepairLogRow.localTextPrefix; }
        protected getNameProperty() { return SecurityRepairLogRow.nameProperty; }
        protected getService() { return SecurityRepairLogService.baseUrl; }
        protected getDeletePermission() { return SecurityRepairLogRow.deletePermission; }
        protected getInsertPermission() { return SecurityRepairLogRow.insertPermission; }
        protected getUpdatePermission() { return SecurityRepairLogRow.updatePermission; }

        protected form = new SecurityRepairLogForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();
            this.editButton.hide();
            this.cloneButton.hide();
            this.deleteButton.hide();
            Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);  
            this.setStatusCode(); 
        }

        protected setStatusCode() {
            if ($(".status").length < 1) {
                $('<p class="status"></p>')
                    .insertAfter(this.form.StatusCode.element)
            }
            $(".status").html(this.getStatusCode(this.form.StatusCode.value));
            if (this.form.StatusCode.value)
                this.form.StatusCode.getGridField().children('.editor').hide();
            else
                this.form.StatusCode.getGridField().toggle(false);
        }

        protected getStatusCode(statusCode: string) { 
            if (!statusCode)
                return "";
            var color;
            if (statusCode === "SUCCEEDED")
                color = "green";
            else if (statusCode.indexOf("FAIL") >= 0)
                color = "red";
            else
                color = "amber";
            return `<span class="text-${color}"><i class="fa fa-circle"> ${Q.htmlEncode(statusCode)}</span>`;
        }
    }
}